export default {
  title: "New Results",
  subtitle: "Recently received laboratory results",
  comingSoon: "Coming Soon",
  description: "This feature will display the most recent laboratory results received.",
};
